// src/pages/MyBookingPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyBooking from "../components/MyBookings";

const LoginPage = () => {
  return (
    <>
      <Header />
      <MyBooking />
      <Footer />
    </>
  );
};

export default LoginPage;
